<template>
  <div class="flex-center">
    <div v-if="authHref">
      <h3>小提示</h3>
      <p>本活动需要您授权登录后即可进入哦~</p>
      <a class="btn-auth" :href="authHref" target="_blank">点击登录</a>
    </div>
  </div>
</template>
<script>
import { createUniqueString } from '@/utils/index'
export default {
  data() {
    return {
      Base_Url: "",
      shortUrlId: "",
      sessionId: "",
      wxCode: '',
      appId: '',
      authHref: ''
    };
  },
  mounted() {
    document.title = '跳转中...'
    this.Base_Url = Config.VUE_APP_BASE_API || process.env.VUE_APP_BASE_API;
    this.shortUrlId = this.$route.params.id;
    this.wxCode = this.$route.query.code
    if (localStorage.getItem('sessionId')) {
      this.sessionId = localStorage.getItem('sessionId');
    }
    else {
      this.sessionId = createUniqueString();
      localStorage.setItem('sessionId', this.sessionId);
    }
    // this.addRecordLog()
    this.buildByShortUrlId();
  },
  methods: {
    buildByShortUrlId() {
      let data = {
        sessionId: this.sessionId,
        shortUrlId: this.shortUrlId
      };
      this.$axios({
        url: this.Base_Url + "mkt/unAuthenticate/url/buildByShortUrlId",
        method: "post",
        data
      }).then((res) => {
        const result = res.data.data
        const APPID = result.appId
        this.appId = APPID
        if (result.shortUrlType == "ExternalToMiniprogram") {
          return window.location.replace(process.env.VUE_APP_VIRTUAL_DIR + "error.html?msg=很抱歉，链接非法");
        }
        if (result.shortUrlType == "H5" && (result.identifyUser == 1 || result.identifyUser == 2)) {
          if (!this.wxCode) {
            if (result.identifyUser == 1) {
              const redirect_url = location.href//encodeURIComponent(location.href)
              const scope = 'snsapi_userinfo' || 'snsapi_base'
              // const component_appid = result.componentAppId
              this.$axios({
                url: this.Base_Url + "mkt/unAuthenticate/app/buildAuthorizationUrl",
                method: "get",
                params: {
                  appId: APPID,
                  redirectUri: redirect_url,
                  scope,
                  state: 'short_link'
                },
              }).then(({ data }) => {
                location.replace(data.data)
              }).catch(err => {
                let msg = null;
                if (err.response && err.response.data && err.response.data.message) {
                  msg = err.response.data.message
                }
                else {
                  msg = "很抱歉，授权异常"
                }
                window.location.replace(process.env.VUE_APP_VIRTUAL_DIR + "error.html?msg=" + msg);
              })
            }
            if (result.identifyUser == 2) {
              const redirect_url = location.href//encodeURIComponent(location.href)
              const scope = 'snsapi_userinfo' || 'snsapi_base'
              // const component_appid = result.componentAppId
              let hasAppId = localStorage.getItem('short_link_' + APPID)
              if (hasAppId) {
                if (new Date() > new Date(hasAppId)) {
                  hasAppId = ''
                }
              }
              this.$axios({
                url: this.Base_Url + "mkt/unAuthenticate/app/buildAuthorizationUrl",
                method: "get",
                params: {
                  appId: APPID,
                  redirectUri: redirect_url,
                  scope,
                  state: 'short_link'
                },
              }).then(({ data }) => {
                if (hasAppId) {
                  location.replace(data.data)
                } else {
                  this.authHref = data.data
                }
              }).catch(err => {
                let msg = null;
                if (err.response && err.response.data && err.response.data.message) {
                  msg = err.response.data.message
                }
                else {
                  msg = "很抱歉，授权异常"
                }
                window.location.replace(process.env.VUE_APP_VIRTUAL_DIR + "error.html?msg=" + msg);
              })
            }
            // const authURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${redirect_url}&response_type=code&scope=${scope}&state=&component_appid=${component_appid}#wechat_redirect`
            return
          }
          this.getUserInfo()
        }
        setTimeout(() => {
          window.location.href = result.url;
        }, 300);
      }).catch(err => {
        let msg = null;
        if (err.response && err.response.data && err.response.data.message) {
          msg = err.response.data.message
        }
        else {
          msg = "很抱歉，链接已失效"
        }
        window.location.replace(process.env.VUE_APP_VIRTUAL_DIR + "error.html?msg=" + msg);
      })
    },

    handleAuth() {
      location.href = this.authHref
    },
    getUserInfo() {
      if (this.appId) {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 30);
        localStorage.setItem('short_link_' + this.appId, currentDate)
      }
      this.$axios({
        url: this.Base_Url + "mkt/unAuthenticate/url/identifyUser",
        method: "post",
        data: {
          sessionId: this.sessionId,
          shortUrlId: this.shortUrlId,
          code: this.wxCode
        },
      })
    },
    addRecordLog() {
      this.$axios({
        url: this.Base_Url + "mkt/unAuthenticate/app/frontEventRecord",
        method: "get",
        params: {
          page: location.href,
          value: this.sessionId,
        },
      })
    }
  }
};
</script>
<style lang='scss' scoped>
.jump_reload {
  border: 1px solid;
  margin: 60px auto;
  width: 200px;
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
}

.flex-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.btn-auth {
  background-color: #2fa62f;
  padding: 10px;
  width: 160px;
  margin: 0 auto;
  color: #fff;
  border-radius: 5px;
  margin-top: 60px;
  display: block;
  text-decoration: none;
}
</style>